var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection1Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 55,
    viewBox: "0 0 78 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.0711 17.4973C17.7714 11.1977 22.2331 0.42627 31.1421 0.42627H67.7107C76.6197 0.42627 81.0814 11.1977 74.7817 17.4973L56.4975 35.7816C52.5922 39.6868 46.2606 39.6868 42.3553 35.7816L24.0711 17.4973Z",
    fill: "#0369A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9875 10.6665H39.1685C39.1685 10.6665 36.8202 46.0188 25.0781 46.0188C19.342 46.0188 15.8476 37.5825 13.7736 28.9521C11.6019 19.9157 10.9875 10.6665 10.9875 10.6665Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1685 10.6664C39.1685 10.6664 41.6251 8.04598 43.6667 7.99974C47.6667 7.90918 48.4061 10.6664 48.4061 10.6664C49.1891 12.2918 49.8152 16.5179 46.0579 20.4188C42.3003 24.3198 38.0941 27.7331 36.3824 28.952",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9874 10.6669C10.9874 10.6669 8.42793 8.01662 6.33321 8.00027C2.33321 7.96904 1.59371 10.6669 1.59371 10.6669C0.810888 12.2923 0.184648 16.5183 3.94214 20.4193C7.69961 24.3203 12.062 27.7336 13.7734 28.9528",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6843 53.3334C15.6843 48.4572 25.0779 46.019 25.0779 46.019C25.0779 46.019 34.4717 48.4572 34.4717 53.3334H15.6843Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1Svg1);
export default __webpack_public_path__ + "static/media/section1svg1.b5ecb24b8bea7bb885919627dc4032ec.svg";
export { ForwardRef as ReactComponent };